
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabservice() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Pune',
    heading: 'AB Ghule Cabs: Corporate Cab Services in Pune',
    headingDescription: 'AB Ghule Cabs offers Corporate Cab Services in Pune tailored to meet the travel needs of businesses and professionals. We understand the importance of punctuality, comfort, and professionalism when it comes to corporate travel. Whether it is airport transfers, business meetings, or employee transportation, our services ensure a smooth and hassle-free experience. With a fleet of well-maintained vehicles and experienced drivers, we provide reliable, cost-effective, and timely cab services for all your corporate travel needs.',

    top: 'Key Corporate Cab Services in Pune with AB Ghule Cabs:',

    topPlaces: [
        {
            title: "Airport Transfers",
            description: "Get to and from Pune Airport with ease. Our timely airport pickup and drop services ensure that you reach your destination on time without any stress. Whether you're heading for a business trip or picking up a client, we make airport transfers simple and convenient."
        },
        {
            title: "Employee Transportation",
            description: "Ensure your employees have a comfortable commute with our employee transportation services. We offer group travel solutions for companies, ensuring a reliable and safe journey for your staff to and from work."
        },
        {
            title: "Business Meetings and Conferences",
            description: "Arrive at your business meetings and conferences in style and comfort. Our corporate cab service ensures that you and your colleagues are on time, relaxed, and ready to focus on your work."
        },
        {
            title: "Client Pickups and Drops",
            description: "Impress your clients with our professional taxi services. We offer reliable, comfortable, and punctual cab services for picking up and dropping off clients, leaving a positive impression of your business."
        },
        {
            title: "Outstation Travel",
            description: "If you have business trips outside Pune, we provide reliable outstation cab services. Whether it's a one-day trip or extended travel, we ensure safe and comfortable journeys to various destinations across Maharashtra and India."
        },
        {
            title: "VIP and Executive Cab Service",
            description: "For VIPs and executives, we offer luxury car options such as sedans and SUVs, ensuring that you travel in style and comfort to your business events, meetings, and conferences."
        },
        {
            title: "Customized Corporate Packages",
            description: "We offer tailored corporate travel packages to suit the specific needs of your business. Whether it’s for a special event, long-term employee transportation, or regular business travel, we customize our services to your requirements."
        },
        {
            title: "Long-Term Corporate Contracts",
            description: "AB Ghule Cabs offers long-term cab rental agreements for companies that need consistent transportation for their employees or business executives. Our service is reliable, cost-effective, and designed to handle regular and multiple trips."
        },
        {
            title: "24/7 Customer Support",
            description: "We provide round-the-clock customer support to ensure your corporate travel needs are met without interruption. Our team is always available to assist with bookings, queries, or any travel changes."
        },
        {
            title: "Corporate Events and Employee Outings",
            description: "We also offer transportation services for corporate events, team outings, or employee retreats. With a fleet capable of accommodating large groups, we ensure that your events are seamless and stress-free."
        }
    ],


    services: [
        {
          "name": "Corporate Cab Services",
          description: "AB Ghule Cabs offers reliable corporate cab services in Pune, providing comfortable and affordable rides for your business needs. Whether it's for office travel, corporate events, or airport transfers, we ensure a seamless experience with professional drivers and well-maintained vehicles."
        },
        {
          "name": "Corporate Cabs in Pimpri Chinchwad",
          description: "For corporate cab services in Pimpri Chinchwad, choose AB Ghule Cabs. We offer well-maintained vehicles and experienced drivers for all your business travel requirements, ensuring comfort and punctuality."
        },
        {
          "name": "Corporate Taxi Services in Pune",
          description: "AB Ghule Cabs offers efficient corporate taxi services in Pune, tailored to meet the specific needs of businesses. We provide reliable, comfortable, and affordable cabs for meetings, events, and daily office commuting."
        },
        {
          "name": "Taxi for Corporate Picnic",
          description: "Make your corporate picnic a memorable experience with AB Ghule Cabs. We offer spacious and comfortable vehicles, including SUVs and minibuses, for group travel to corporate picnics and outings."
        },
        {
          "name": "Corporate Airport Transfer Pune",
          description: "For hassle-free corporate airport transfers in Pune, trust AB Ghule Cabs. We offer punctual and reliable taxi services to and from Pune airport, ensuring a smooth and professional experience for your team and clients."
        },
        {
          "name": "Corporate Cab Booking",
          description: "Book your corporate cab with AB Ghule Cabs for a comfortable and reliable travel experience. Our easy online booking system allows you to reserve cabs for corporate events, meetings, and daily office commuting."
        },
        {
          "name": "Corporate Taxi Booking",
          description: "AB Ghule Cabs offers corporate taxi booking services for all your business travel needs. With a wide range of vehicles, we ensure timely pickups and drop-offs, making your corporate travel hassle-free."
        },
        {
          "name": "Corporate Taxi Hire in Pune",
          description: "Hire a corporate taxi in Pune with AB Ghule Cabs for all your business travel needs. We offer a range of vehicles, including luxury cabs, to ensure a comfortable and professional journey."
        },
        {
          "name": "Innova Crysta for Corporate Cab",
          description: "AB Ghule Cabs offers Innova Crysta for corporate cab services in Pune. Perfect for business travel, it provides comfort, space, and luxury for executives and team members."
        },
        {
          "name": "Innova Crysta Taxi for Outstation",
          description: "Book an Innova Crysta taxi for your outstation corporate trips with AB Ghule Cabs. Enjoy a comfortable and spacious ride with professional drivers for all your business needs."
        },
        {
          "name": "7-Seater Cab for Corporate Outstation",
          description: "For corporate outstation travel, AB Ghule Cabs provides 7-seater cabs. These spacious vehicles ensure comfort and convenience for your team during long-distance journeys."
        },
        {
          "name": "Kia Carens on Rent for Corporate Picnic",
          description: "Rent a Kia Carens for your corporate picnic with AB Ghule Cabs. Its spacious and comfortable design makes it perfect for group outings and corporate events."
        },
        {
          "name": "Sedan Cabs on Rent for Corporate",
          description: "AB Ghule Cabs offers sedan cabs on rent for corporate travel in Pune. With professional drivers and well-maintained vehicles, we provide comfort and efficiency for your business needs."
        },
        {
          "name": "Corporate Cab Services in Kharadi",
          description: "AB Ghule Cabs offers corporate cab services in Kharadi, Pune. We provide punctual and reliable services for your office trips, meetings, and corporate events with a fleet of well-maintained vehicles."
        },
        {
          "name": "Corporate Cab Services in Hadapsar",
          description: "For corporate cab services in Hadapsar, choose AB Ghule Cabs. We offer comfortable, safe, and affordable taxi services to meet your business needs, ensuring smooth and timely transportation."
        },
        {
          "name": "Corporate Cab Services in Magarpatta City",
          description: "AB Ghule Cabs provides corporate cab services in Magarpatta City, Pune. Whether it’s for daily office commuting, corporate events, or business meetings, we ensure a seamless travel experience."
        },
        {
          "name": "Corporate Cab Services in Hinjewadi",
          description: "Book corporate cab services in Hinjewadi with AB Ghule Cabs for a hassle-free travel experience. We offer reliable and professional services for your business trips, with well-maintained vehicles and experienced drivers."
        },
        {
          "name": "Corporate Cab Services in Talawade Pune",
          description: "For corporate cab services in Talawade, Pune, AB Ghule Cabs provides comfortable, on-time taxi services for office commuting and business-related travel. Our vehicles are well-maintained for a smooth ride."
        },
        {
          "name": "Cab Vendors in Pune",
          description: "AB Ghule Cabs is one of the most trusted cab vendors in Pune, offering reliable taxi services for corporate and personal travel. We provide well-maintained vehicles and experienced drivers to cater to your needs."
        },
        {
          "name": "Monthly Cab on Rent in Pune",
          description: "For a monthly cab on rent in Pune, choose AB Ghule Cabs. We offer flexible rental options, ensuring that your business travel needs are met with reliability, comfort, and convenience."
        },
        {
          "name": "Corporate Cab Services in Pune Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Corporate Cab Services in Pune. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData : [
        ["- Corporate Cab Services", "- Corporate cabs in pimpri chinchwad"],
        ["- Corporate taxi services in Pune", "- Taxi for corporate Picnic"],
        ["- Corporate airport transfer Pune", "- Corporate cab booking"],
        ["- Corporate taxi booking", "- Corporate taxi hire in Pune"],
        ["- Innova crysta for corporate cab", "- Innova crysta taxi for outstation"],
        ["- 7 seater cab for corporate outstation", "- Kia Carens on rent for corporate picnic"],
        ["- Sedan cabs on rent for corporate", "- Corporate cab services in Kharadi"],
        ["- Corporate cab services in Hadapsar", "- Corporate cab services in Magarpatta City"],
        ["- Corporate cab services in Hinjewadi", "- Corporate cab services in Talawade Pune"],
        ["- Cab vendors in Pune", "- Monthly cab on Rent in Pune"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "AB Ghule Cabs offers reliable and professional corporate cab services in Pune. Whether you need transportation for business meetings, client pickups, or daily employee commuting, our services are designed to meet the high standards of corporate travel with punctuality and comfort."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We understand that business trips can happen at any time, which is why our corporate cab service operates 24/7. Whether it’s early morning or late at night, we ensure your employees and clients are transported safely and efficiently at any time of day."
        },
        {
          WhyChooseheading: "Affordable and Transparent Pricing",
          WhyChoosedescription: "We provide competitive and transparent pricing, offering cost-effective solutions for corporate travel. Our pricing structures are designed to suit different corporate budgets, with no hidden charges, ensuring your business gets value for money."
        },
        {
          WhyChooseheading: "Wide Range of Vehicles",
          WhyChoosedescription: "We offer a variety of vehicles, including sedans, SUVs, and luxury cars, to cater to the diverse needs of corporate clients. Whether it’s an individual business trip, group travel, or transportation for VIPs, we provide the right vehicle for the job."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Safety and comfort are our top priorities. Our fleet of vehicles is well-maintained, equipped with modern safety features, and driven by experienced, background-checked drivers to ensure a smooth and safe ride for your employees or clients."
        },
        {
          WhyChooseheading: "Efficient Booking and Scheduling",
          WhyChoosedescription: "Booking corporate cabs with AB Ghule Cabs is simple and quick. You can book rides through our easy-to-use website, mobile app, or by contacting our customer service team. We also provide easy scheduling for recurring trips, ensuring your employees have reliable transportation when needed."
        },
        {
          WhyChooseheading: "Customizable Corporate Packages",
          WhyChoosedescription: "We offer customizable packages to cater to the unique needs of your business. Whether it’s for long-term employee transport, VIP client transport, or one-time business events, we can tailor a solution that best suits your company’s needs."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "Our focus on customer satisfaction has earned us a loyal corporate clientele. With our commitment to high-quality service, punctuality, and professionalism, we ensure that your corporate travel experience is smooth and efficient every time."
        }
      ]
      
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a corporate cab with AB Ghule Cabs?',
      answer: 'You can easily book a corporate cab through our website, mobile app, or by calling our customer service team. We also offer easy scheduling options for recurring trips, making the process seamless for your business.',
    },
    {
      id: 'FAQ2',
      question: 'Do you offer corporate cab services for group travel?',
      answer: 'Yes, we provide spacious vehicles, such as SUVs and vans, to accommodate group travel. Whether you need transportation for a team meeting, conference, or corporate event, we can cater to your needs.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for corporate travel?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars. We can help you choose the right vehicle depending on your needs, whether it’s for individual executive travel or larger groups.',
    },
    {
      id: 'FAQ4',
      question: 'Are the drivers experienced and professional?',
      answer: 'Yes, all our drivers are experienced, professional, and background-checked. They are trained to provide the highest level of service, ensuring your employees or clients have a safe and comfortable journey.',
    },
    {
      id: 'FAQ5',
      question: 'What payment options are available for corporate travel?',
      answer: 'For corporate bookings, we offer flexible payment options, including monthly billing, credit/debit cards, or online payments through our app or website, ensuring a convenient and efficient process for businesses.',
    },
    {
      id: 'FAQ6',
      question: 'Can I arrange for recurring transportation for employees?',
      answer: 'Yes, we offer solutions for regular employee transport. You can schedule recurring rides with us, whether for daily commutes, airport transfers, or specific business needs.',
    },
    {
      id: 'FAQ7',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'There may be additional charges for waiting time, detours, or extended trips. However, we maintain transparency in pricing, and any extra charges will be communicated to you upfront.',
    },
    {
      id: 'FAQ8',
      question: 'Can I cancel or modify my corporate booking?',
      answer: 'Yes, you can easily modify or cancel your corporate booking through our website or app. You can also contact our customer service team for assistance with any changes or cancellations.',
    },
    {
      id: 'FAQ9',
      question: 'What sets AB Ghule Cabs apart from other corporate cab services?',
      answer: 'AB Ghule Cabs is known for its commitment to professional and reliable service, punctuality, safety, and customer satisfaction. We offer tailored solutions for corporate needs, whether it’s for employee commutes, client transportation, or corporate events.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Vishal Mehta",
      position: "HR Manager, Tech Solutions Ltd.",
      feedback: "We've been using AB Ghule Cabs for our corporate transportation needs, and we are extremely satisfied with their service. Their drivers are professional, punctual, and reliable, and the booking process is seamless.",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Aarti Sharma",
      position: "Event Coordinator, International Ventures",
      feedback: "AB Ghule Cabs has been our go-to service provider for client transportation. Their vehicles are always clean, and the drivers are courteous. We highly recommend them for any corporate travel needs in Pune.",
      rating: 5,
    },
  ];
  





  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Corporate Cab Service in Pune | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Get professional corporate cab services in Pune with AB Ghule Cabs. Offering corporate taxi booking, vehicle rental, long-term cab rentals, and monthly cab services for businesses. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune Corporate Cab Services, Pune Corporate Taxi Booking, Pune Corporate Car Rental, Pune Corporate Transportation Services, Pune Corporate Car Hire, Pune Corporate Taxi Rates, Pune Corporate Vehicle Rental, Pune Corporate Taxi Packages, Pune Corporate Transport Solutions, Pune Monthly Service Cabs, Pune Monthly Cab Services, Pune Monthly Taxi Hire, Pune Monthly Car Rental, Pune Monthly Cab Booking, Pune Monthly Taxi Packages, Pune Monthly Car Lease, Pune Monthly Cab Rates, Pune Monthly Taxi Costs, Pune Long-Term Cab Rentals, Corporate cab service in Pune contact number" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Corporate Cab Service in Pune | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Get professional corporate cab services in Pune with AB Ghule Cabs. Offering corporate taxi booking, vehicle rental, long-term cab rentals, and monthly cab services for businesses. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/corporate-cab-service.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/corporate-cab-service" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Corporate Cab Service in Pune",
        description: "Get professional corporate cab services in Pune with AB Ghule Cabs. Offering corporate taxi booking, vehicle rental, long-term cab rentals, and monthly cab services for businesses. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/corporate-cab-service",
        "logo": "https://abghulecabs.com/images/corporate-cab-service.jpg",
        "image": "https://abghulecabs.com/images/corporate-cab-service.jpg",
        "priceRange": "₹500 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/corporate-cab-service",
          "priceCurrency": "INR",
          "price": "500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Siddhi A"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "We’ve been using AB Ghule Cabs for our corporate needs for over a year. Excellent service, punctual drivers, and affordable rates. Highly recommended for businesses."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Manoj R"
            },
            "datePublished": "2024-10-12",
            "reviewBody": "Their monthly cab service is great. We have been using them for our office commute, and they provide reliable and professional drivers at competitive rates."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Corporate Cab Service in Pune",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/corporate-cab-service"
        },
        "keywords": "Pune Corporate Cab Services, Pune Corporate Taxi Booking, Pune Corporate Car Rental, Pune Corporate Transportation Services, Pune Corporate Car Hire, Pune Corporate Taxi Rates, Pune Corporate Vehicle Rental, Pune Corporate Taxi Packages, Pune Corporate Transport Solutions, Pune Monthly Service Cabs, Pune Monthly Cab Services, Pune Monthly Taxi Hire, Pune Monthly Car Rental, Pune Monthly Cab Booking, Pune Monthly Taxi Packages, Pune Monthly Car Lease, Pune Monthly Cab Rates, Pune Monthly Taxi Costs, Pune Long-Term Cab Rentals, Corporate cab service in Pune contact number"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/68.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Corporatecabservice;